import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$9f59 from '/workspace/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as wordpressRuntime$f16a from '/workspace/providers/wordpress.js'

const imageOptions = {
  "screens": {
    "xs": 0,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "wordpress",
  "domains": [
    "libertyhomes.bizonweb.it",
    "www.libertyhomes.it"
  ],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$9f59, defaults: {} },
  ['wordpress']: { provider: wordpressRuntime$f16a, defaults: {} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
